/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { SupportHours } from "~/models";
import {
  ARAttachedSlas,
  AssignmentRuleRouteParams,
} from "~/models/assignmentRule";
import { InlineEditSLA } from "../SLA/components/InlineEditSLA";

type Props = {
  refetch: () => void;
  sla: ARAttachedSlas["sla"];
  val: string;
  supportHours: SupportHours;
  comm: string;
  serviceId: string;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function AREditSLA({
  refetch,
  sla,
  val,
  comm,
  serviceId,
  supportHours,
}: Props) {
  const {
    customerId,
    assignmentRuleId,
  } = useParams<AssignmentRuleRouteParams>();
  const editARSLAUrl = `/customers/${customerId}/assignmentRules/${assignmentRuleId}/services/${serviceId}/slas/${sla?.id}/data`;

  return (
    <>
      <InlineEditSLA
        refetch={refetch}
        sla={sla}
        val={val}
        supportHours={supportHours}
        comm={comm}
        editURL={editARSLAUrl}
      />
    </>
  );
}
